<template>
  <v-container fluid style="overflow-x: scroll !important;">
    <h2 style="text-align: center;">กรุณาเลือกข้อความที่ท่านต้องการ 

      <span v-if="countMulti > 1"> จำนวน {{multi_select}} ข้อความ </span> 
      </h2>
      <!-- {{selected}} -->
<!--       {{countMulti}}
       {{selected.length == countMulti }}
      {{selected.length == countMulti && countMulti != 1}} -->

      <!-- <v-chip
        v-model="selected[0]"
        close
        color="red"
        text-color="white"
      >{{selected[0]}}</v-chip> -->
 <div v-if="selected.length !=0">
   ข้อความที่เลือก: <span v-for="(item, index) in selected"> <span v-if="index != 0">,</span> {{item}} </span>

<v-btn class="buttonSelect" dark @click="clearSelected()">
            ลบที่เลือก
          </v-btn>

   <v-btn class="buttonSelect" dark @click="answerModal(selected)" v-if="(selected.length == countMulti && countMulti != 1) || countMulti == -1">
            ส่ง
          </v-btn>
 </div>

     <!-- <v-btn class="buttonSelect" dark @click="answerModal(textselect)" v-if="(selected.length == countMulti && countMulti != 1) || countMulti == -1">
            ส่ง
          </v-btn> -->
<!-- if (this.selected.length == this.countMulti) {
        this.answerModal(this.textselect)
      } -->
      <br>

    <img id="scream" :src="data.img_result? 'data:image/jpeg;base64,' + data.img_result:''" alt="The Scream" style="display: none;">

    <canvas id="myCanvas" v-if="!loadingData"> </canvas>

 <v-layout wrap v-else>
        <v-flex sm12 md12 lg12 xl12 style="justify-content: center; display: grid;height: 80vh;">
    <v-progress-linear  v-model="value" style="width: 95vw !important; margin: auto;" height="20" background-color="#80a7d8" color="#0e468e" >
            <strong style="color: white !important;    justify-content: center;text-align: center;display: flex;">{{ Math.ceil(value) }}%</strong>
          </v-progress-linear>
        </v-flex>
      </v-layout>
<!--     {{xy}}
    <br/> -->
    




    <v-dialog v-model="dialogEdit_text" max-width="80%" persistent style="overflow-y: hidden; border-radius: 20px !important;">
    <v-card style="border-radius:20px;">
<v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai">
            <v-layout row wrap>
              <h3>ยืนยันข้อความ</h3>
            </v-layout>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon flat @click="closeDialog">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>

      <v-card-text class="" style="overflow-x: hidden;">
        <v-text-field outline v-model="textselect"></v-text-field>
        <div style="display: flex; justify-content: center;">
      <v-btn @click="closeDialog()" class="buttonCancel">ยกเลิก</v-btn>

      <v-btn @click="selectTextConfirm()" class="buttonSelect">ยืนยัน</v-btn>
    </div>


      </v-card-text>
    </v-card>
  </v-dialog>









  </v-container>
</template>
<script type="text/javascript">
var _ = require('lodash')
export default {
  data: () => ({
    res: {},
    imgWidths: 0,
    imgHeight: 0,
    xy: '',
    textselect: '',
    dialogEdit_text: false,
    // img: 'https://p.bigstockphoto.com/GeFvQkBbSLaMdpKXF1Zv_bigstock-Aerial-View-Of-Blue-Lakes-And--227291596.jpg',
    data: {},
    tokenuser: '',
    tokenroom: '',
    source_image_url: '',
    loadingData: false,
    interval: 0,
    value: 0,
    multi_select: '',
    selected: [],
    countMulti: 1
  }),
  watch: {
    imgWidths () {
      let canvasElem = document.querySelector('canvas')
      var me = this
      var img = document.getElementById('scream')
      var canvas = document.getElementById('myCanvas')
      // console.log(this.imgWidths)
      canvas.setAttribute('width', this.imgWidths)
      canvas.setAttribute('height', this.imgHeight)
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      canvasElem.addEventListener('mousedown', function (e) {
        me.getMousePosition(canvasElem, e)
      })
    }
    // selected () {
    //   // console.log(this.selected.filter(function(item) {
    //   //   return item !== false
    //   // }))
    //   this.selected = this.selected.filter(function(item) {
    //     return item !== false
    //   })
    // }
  },
  mounted () {
    // let canvasElem = document.querySelector('canvas')
    // var me = this
    // var img = document.getElementById('scream')
    // var canvas = document.getElementById('myCanvas')
    // console.log(this.imgWidths)
    // canvas.setAttribute('width', this.imgWidths)
    // canvas.setAttribute('height', this.imgHeight)
    // var ctx = canvas.getContext('2d')
    // ctx.drawImage(img, 5, 5)
    // canvasElem.addEventListener('mousedown', function (e) {
    //   me.getMousePosition(canvasElem, e)
    // })
  },
  created () {
    // console.log('test')
    this.id = this.$route.query.id
    this.multi_select = this.$route.query.multi_select
    this.get_id()
    if(this.multi_select != 'true' && this.multi_select != 'false' && parseInt(this.multi_select)) {
      this.countMulti = parseInt(this.multi_select)
    } else if(this.multi_select == 'true') {
      this.countMulti = -1
    } else {
      this.countMulti = 1
    }
  },
  methods: {
    closeDialog () {
      this.dialogEdit_text = false
    },
    clearSelected () {
      this.selected = []
    },
    queryAndIndeterminate () {
      this.value = 0

      // setTimeout(() => {
        var step = 0.3
        var current_progress = 0
        var me = this
        this.interval = setInterval(function() {
          current_progress += step;
          me.value = Math.round(Math.atan(current_progress) / (Math.PI / 2) * 100 * 1000) / 1000
          if (me.value >= 100){
            clearInterval(me.interval)
          } else if(me.value >= 70) {
            step = 0.1
          }
        }, 100)
      // }, 2500)
    },
    get_id () {
      this.loadingData = true
      this.queryAndIndeterminate()
      this.$http.get('https://l.one.th/onechat-ocr/api/v1/get-ocr-data/' + this.id).then((response) => {
        this.value = 100
        this.loadingData = false
        this.data = response.data.data['data-ocr']
        this.source_image_url = response.data.data['source_image_url']
        this.tokenuser = response.data.data['tokenuser']
        this.tokenroom = response.data.data['tokenroom']
        const img = new Image()
        img.src = 'data:image/jpeg;base64,' + this.data.img_result
        var me = this
        img.onload = function () {
          me.imgWidths = img.naturalWidth
          me.imgHeight = img.naturalHeight
        }
      }, (response) => {})
    },
    answerModal (selected) {
      var body = {
        "tokenuser": this.tokenuser,
        "tokenroom": this.tokenroom,
        "list_text": {"source_image_url": this.source_image_url, "text_select": selected},
        "type_reply": "ocr"
      }
      this.$http.post(process.env.APIalpine + '/api/v1/answer_quickreply', body).then((response) => {
        // console.log(response.data)
        if (response.body['status'] === 'success') {
          this.selected = []
          this.$swal(
            '',
            'สำเร็จแล้ว',
            'success'
          )
        }
      }, (response) => {})
    },
    selectTextConfirm () {
      this.closeDialog()
      // this.selected.push(this.textselect)
      // console.log(this.selected)
      // if (this.selected.length == this.countMulti) {
      //   this.answerModal(this.textselect)
      // }
      if (this.countMulti == 1) {
        this.answerModal([this.textselect])
      } else {
        if (this.selected.length == this.countMulti) {
          this.$swal(
            '',
            'คุณเลือกเกินจำนวนที่ระบบกำหนดไว้',
            'warning'
          )
        } else {
          this.selected.push(this.textselect)
        }
        
      }
      // this.answerModal([this.textselect])
    },
    getMousePosition (canvas, event) {
      let rect = canvas.getBoundingClientRect()
      let x = event.clientX - rect.left
      let y = event.clientY - rect.top
      this.xy = 'Coordinate x: ' + x + ' Coordinate y: ' + y
      var index = _.findIndex(this.data.result, function (o) { return y >= o.position.ymin && y <= o.position.ymax && x >= o.position.xmin && x <= o.position.xmax })
      // console.log(this.data.result[index])
      this.textselect = this.data.result[index].result
      this.dialogEdit_text = true
      // this.answerModal([this.textselect])
      // console.log('Coordinate x: ' + x, ' Coordinate y: ' + y)
    },
    checksizeImage () {
      const img = new Image()
      img.src = this.data.img_result
      var me = this
      img.onload = function () {
        me.imgWidths = img.naturalWidth
        me.imgHeight = img.naturalHeight
      }
    }
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
.buttonCancel {
  border-radius: 25px;
  box-shadow: none !important;
}
.buttonSelect {
  background: #19212c !important;
  color: white !important;
  border-radius: 25px !important;
  box-shadow: none !important;
}
>>>.v-text-field--outline input {
  margin: auto !important; 
}
/*h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}*/
</style>



// WEBPACK FOOTER //
// src/components/testcanvas.vue